import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Price, PriceRule} from "@app/models/price-rule";
import {PackageInfoModel} from "@app/models/package-info";
import {Config, DefaultConfig} from "ngx-easy-table";
import {EasyColumns, EasyTableEvent, sm} from "@shared/components/easy-table.component";
import {PackageModel} from "@app/@core/domain/package.model";
import {CourseService} from "@app/@core/services/course.service";
import {PriceRuleRepository} from "@app/@core/repositories/price-rule.repository";


@Component({
  selector: 'app-package-info-table',
  template: `
    <app-easy-table #table
                    [configuration]="configuration"
                    [columns]="columns"
                    [data]="items"
                    (rowClick)="onRowClick($event)"
                    [showFooter]="false"
    ></app-easy-table>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class PackageInfoTableComponent implements OnInit {
  @Input() items: PackageModel.PackageInfo[];

  @Output() rowClick = new EventEmitter<PackageModel.PackageInfo>();


  configuration: Config = {
    ...DefaultConfig,
    paginationEnabled: false,
    rows: 100
  };

  columns: EasyColumns<PackageModel.PackageInfo>[] = sm([
    {key: 'name.en', title: 'Name', cssClass: {includeHeader: false, name: 'text-primary text-sm'}},

    {key: 'category.title.en', title: 'Category Type'},
    // {key: '', title: 'To', type: 'date'},
    // {key: 'isActive', title: 'Act', type: 'boolean'},
    // {
    //     key: '', title: 'Note', func: (v, row) => {
    //         // if (row.freeCart || row.freeCaddy){
    //         //     return `Free ${row.freeCart ? 'CT' : '-'}/${row.freeCaddy ? 'CD' : '-'}`;
    //         // }
    //         return '';
    //     }
    // },
    // {key: 'party', title: 'Party', type: 'boolean'},
    // {key: '', title: 'Golfer', func: (v, row) => `${row.minperson}-${row.maxperson}`},
  ]);
  rows: { source: any }[];
  selectedCourse: string;

  constructor(
    public courseService: CourseService,
    public priceRuleService: PriceRuleRepository,
  ) {
  }

  ngOnInit(): void {
  }

  onRowClick($event: EasyTableEvent<PackageModel.PackageInfo>) {
    this.rowClick.emit($event.value.row.source);
  }
}
